// import React from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { togglePostEditorModal } from "../../redux/slicers/modalSlicer";
// import * as postSlicerActions from "../../redux/actions/postActions";
// import { useTranslation } from "react-i18next";

// const PostModal = () => {
//   const { t } = useTranslation();
//   const post = useSelector((state) => state.modal.postEditorModal);
//   const dispatch = useDispatch();

//   const handleDelete = () => {
//     dispatch(postSlicerActions.deletePost(post._id));
//     handleClose();
//   };

//   const handleClose = () => {
//     dispatch(togglePostEditorModal());
//   };

//   return post ? (
//     <div className="post-delete-modal">
//       <div className="post-delete-modal__wrapper">
//         <div className="post-delete-modal__text">
//           <h2>{t("deletePostTitle")}</h2>
//           <p>{t("deletePostMessage")}</p>
//         </div>
//         <div className="post-delete-modal__btns display-flex flex-direction-c">
//           <button className="delete" onClick={handleDelete}>
//             {t("delete")}
//           </button>
//           <button className="cancel" onClick={handleClose}>
//             {t("cancel")}
//           </button>
//         </div>
//       </div>
//     </div>
//   ) : null;
// };

// export default PostModal;

import React from "react";
import { IonActionSheet } from "@ionic/react";
import { useSelector, useDispatch } from "react-redux";
import { togglePostEditorModal } from "../../redux/slicers/modalSlicer";
import * as postSlicerActions from "../../redux/actions/postActions";
import {
  trashOutline,
  closeOutline,
  pinOutline,
  pin,
  starOutline,
  star,
  eyeOutline,
  eyeOffOutline,
} from "ionicons/icons";
import { useTranslation } from "react-i18next";
import { useIonRouter } from "@ionic/react";
import { client } from "../../api/client";

const PostModal = () => {
  const { t } = useTranslation();
  const post = useSelector((state) => state.modal.postEditorModal);
  const currentUser = useSelector((state) => state.currentProfile.data);

  const isAdmin = currentUser?.isAdmin;
  const dispatch = useDispatch();
  const router = useIonRouter();

  const handleClose = () => {
    dispatch(togglePostEditorModal());
  };

  const handleDelete = () => {
    if (post?._id) {
      dispatch(postSlicerActions.deletePost(post._id));
    }
    handleClose();
    router.push("/home/discover/latest", "root");
  };

  const handlePin = async () => {
    if (post?._id) {
      await dispatch(postSlicerActions.pinPost(post._id));
      // Refresh posts to show updated state
      dispatch(postSlicerActions.getAllPosts(1));
    }
    handleClose();
  };

  const handleUnpin = async () => {
    if (post?._id) {
      await dispatch(postSlicerActions.unpinPost(post._id));
      // Refresh posts to show updated state
      dispatch(postSlicerActions.getAllPosts(1));
    }
    handleClose();
  };

  const handleFeature = async () => {
    if (post?._id) {
      await dispatch(postSlicerActions.featurePost(post._id));
      // Refresh posts to show updated state
      dispatch(postSlicerActions.getAllPosts(1));
    }
    handleClose();
  };

  const handleUnfeature = async () => {
    if (post?._id) {
      await dispatch(postSlicerActions.unfeaturePost(post._id));
      // Refresh posts to show updated state
      dispatch(postSlicerActions.getAllPosts(1));
    }
    handleClose();
  };
  const markFounder = async () => {
    if (post?.author?.username) {
      await client.put("/profile/admin/mark-founder", {
        username: post?.author?.username,
      });
      dispatch(postSlicerActions.getAllPosts(1));
      dispatch(postSlicerActions.getPostById(post._id)); // Refresh post details if currently viewing
    }
    handleClose();
  };
  const unmarkFounder = async () => {
    if (post?.author?.username) {
      await client.put("/profile/admin/unmark-founder", {
        username: post?.author?.username,
      });
      dispatch(postSlicerActions.getAllPosts(1));
      dispatch(postSlicerActions.getPostById(post._id)); // Refresh post details if currently viewing
    }
    handleClose();
  };
  // Build buttons array
  const buttons = [];

  // Admin-only options
  if (isAdmin && post) {
    if (post.isPinned) {
      buttons.push({
        text: "Unpin Post",
        icon: pinOutline,
        handler: handleUnpin,
      });
    } else {
      buttons.push({
        text: "Pin Post",
        icon: pin,
        handler: handlePin,
      });
    }
    if (post.author.isFounder) {
      buttons.push({
        text: "Unmark as Founder",
        icon: starOutline,
        handler: unmarkFounder,
      });
    } else {
      buttons.push({
        text: "Mark as Founder",
        icon: star,
        handler: markFounder,
      });
    }

    if (post.isFeatured) {
      buttons.push({
        text: "Unfeature Post",
        icon: starOutline,
        handler: handleUnfeature,
      });
    } else {
      buttons.push({
        text: "Feature Post",
        icon: star,
        handler: handleFeature,
      });
    }

    if (post.isHidden) {
      buttons.push({
        text: "Unhide Post",
        icon: eyeOutline,
        handler: async () => {
          if (post?._id) {
            await dispatch(postSlicerActions.unhidePost(post._id));
            dispatch(postSlicerActions.getAllPosts(1));
          }
          handleClose();
        },
      });
    } else {
      buttons.push({
        text: "Hide Post",
        icon: eyeOffOutline,
        handler: async () => {
          if (post?._id) {
            await dispatch(postSlicerActions.hidePost(post._id));
            dispatch(postSlicerActions.getAllPosts(1));
          }
          handleClose();
        },
      });
    }
  }

  // Delete option (for post owner or admin)
  const isMyPost = currentUser?.username === post?.author?.username;
  if (isMyPost || isAdmin) {
    buttons.push({
      text: t("delete"),
      role: "destructive",
      icon: trashOutline,
      handler: handleDelete,
    });
  }

  // Cancel button
  buttons.push({
    text: t("cancel"),
    role: "cancel",
    icon: closeOutline,
  });

  return (
    <IonActionSheet
      isOpen={!!post}
      onDidDismiss={handleClose}
      trigger="open-action-sheet"
      header={isAdmin ? "Post Options" : t("deletePostTitle")}
      buttons={buttons}
    />
  );
};

export default PostModal;
